<nav class="left-nav">
  <div>
    <img class="k-cursor-pointer" src="./assets/nycps-logo.svg" routerLink="/" alt="NYC Public Schools" />
  </div>
  <div *ngIf="showNavigation()" class="navigation-container">
    <a *ngFor="let item of navigationItems" class="link-item navigation-item" [routerLink]="item.route"
      routerLinkActive="active">
      <div class="icon-test-container">
        <ng-container>
          <kendo-svg-icon class="nav-icon" [icon]="item.svg" size="xlarge"></kendo-svg-icon>
        </ng-container>
        <div>{{ item.name }}</div>
      </div>
    </a>
  </div>
</nav>